import React, {Component} from "react";

import "./DocumentUploadingTab.css";
import {Button, message, Typography, Form, Row, Col, Divider, Switch} from "antd";
import UploadWrapper from "./UploadWrapper";
import {displayError, displayGenericError, displaySuccessMessage} from "../common/notifications";
import {
    deleteFile, findSchedule,
    // generateCustomerFileDownloadLink,
    generateUploadedFile, generateUploadedFileNotDownload,
    getCorporateAccountDetails, getCurrentCustomer,
    setupSchedule,
    submitDocumentCorporateAccount,
    upload
} from "../api/api";
import Radio from "antd/es/radio";
import idSelfie from "./images/id-selfie.png";
import idCard from "./images/id_card.png";
import passport from "./images/Passport-1.jpg";
import "./DocumentIndividualUploadingTab.scss"

import DayPicker from "react-day-picker";
import 'react-day-picker/lib/style.css';
import TimePicker from "antd/lib/time-picker";
import moment from "moment";
import Webcam from "react-webcam";
import LoadingIndicator from "./LoadingIndicator";
import get from "lodash/get";
const {Title, Text, Paragraph} = Typography;

const PERSONAL_DOCUMENTS_TYPES = [
    {value: "IDENTITY_CARD_BACK", text: "Identity Card (Back)"},
    {value: "IDENTITY_CARD_FRONT", text: "Identity Card (Front)"},
    {value: "PROOF_OF_ADDRESS", text: "Proof of Address"},
    {value: "PASSPORT", text: "Passport"},
]

class DocumentIndividualUploadingTab extends Component {
    state = {
        documents: this.props.customerAccount.personalAccountDetails.documents || {},
        documentType:'identityCard',
        selectedDay: null,
        selectTime: null,
        onboardingType:'',
        selfieImageName:'',
        selfieImgLink:'',
        isLoading: false,
        guiText:'We will contact you to conduct a Video Call for Identity Verification. Please select a time slot (SGT time):',
        isSubmitted: false,
        isOnCamera: false
    }
    onDocumentTypeChange = (event) =>{
        this.setState({
            documentType: event.target.value
        })
    }
    onBoadingTypeChange = (event) =>{
        this.setState({
            onboardingType: event.target.value
        },()=>{
            if(this.state.onboardingType === 'timeSchedule'){
                this.setState({
                    guiText:'We will contact you to conduct a Video Call for Identity Verification. Please select a time slot (SGT time):'
                })
            }
            else if(this.state.onboardingType ==='selfie'){
                this.setState({
                    guiText:'Please hold your NRIC/Passport next to your face'
                })
            }
        })
    }
    handleRemoveFile = ({id, type, index}) => {
        deleteFile(id)
            .then(() => {
                if (!(typeof index === "number")) {
                    const {documents} = this.state;
                    delete documents[type];
                    this.setState({documents});
                }
            })
            .catch(displayGenericError);
    };
    handleUpload = ({file, type, index}) => {
        if (!(typeof index === "number")) {
            return upload({id: this.props.customerAccount.id, file, type})
                .then(res => {
                    this.setState({
                        documents: {
                            ...this.state.documents,
                            [type]: {
                                name: file.name,
                                size: file.size / 1024,
                                id: res.id
                            }
                        }
                    });
                })
                .catch(displayGenericError);
        }
    };
    isSubmitButtonDisabled = () => {
        let response = true;
        const accountStatus = get(this.props.customerAccount, "status", null);
        if(!accountStatus || accountStatus === 'REVIEW_REQUIRED'){
            return true;
        }
        if(this.state.documentType == 'identityCard'){
            if(!this.state.documents['IDENTITY_CARD_BACK'] || !this.state.documents['IDENTITY_CARD_FRONT']){
                return true;
            }
        } else {
            if(!this.state.documents['PASSPORT'] || !this.state.documents['PROOF_OF_ADDRESS']){
                return true;
            }
        }

        if(this.state.onboardingType === 'timeSchedule'){
            if(this.state.selectedDay != null && this.state.selectTime != null){
                return false;
            }
         } else if(this.state.onboardingType === 'selfie') {
            if(this.state.selfieImageName != '' && this.state.selfieImgLink != ''){
                return false;
            }
        }



        return response;
    }
    toggleCamera = () => {
        let isOnCamera = this.state.isOnCamera;
        this.setState({
            isOnCamera: !isOnCamera
        });
    }

    handleSubmit = () => {
            this.props.updateOnboardingForm({
                dateSelect:this.state.dateSelect,
                timeSelect: this.state.selectTime,
                onboardingType:this.state.onboardingType,
                selfieImgLink: this.state.selfieImgLink,
                documentType:this.state.documentType,
                documents: this.state.documents
            })

    };



    componentDidMount() {

        if (this.state.documents['IDENTITY_CARD_BACK'] && this.state.documents['IDENTITY_CARD_FRONT']
            && this.state.documents['PROOF_OF_ADDRESS']) {
            this.setState({
                documentType: 'identityCard'

            })
        }
        let tomorrow = new Date();
        tomorrow.setDate(tomorrow.getDate() + 1);
        this.setState({
            document: this.props.customerAccount.documents || {},
            //selectedDay: tomorrow
        })

        getCurrentCustomer()
            .then(response =>{
                if (response.status == "PENDING") {
                    this.setState({
                        isSubmitted: true,
                    })
                } else if (!response) {
                    getCorporateAccountDetails()
                        .then(response => {
                            if (response.status == "PENDING") {
                                this.setState({
                                    isSubmitted: true,
                                })
                            }
                        })
                        .catch(error => {
                            this.setState({
                                isLoading: false
                            });
                            displayGenericError(error);
                        });
                }

            })
            .catch(error => {
                this.setState({
                    isLoading: false
                });
                displayGenericError(error);
            });

        findSchedule()
            .then(response => {
                if (response.dateSelect) {
                    this.setState({
                        dateSelect: response.dateSelect,
                    })
                } else if (this.state.documents.SELFIE){
                    generateUploadedFileNotDownload(this.state.documents.SELFIE.id)
                        .then(response => {
                            if (response) {
                                this.setState({
                                    onboardingType: "selfie",
                                    selfieImageName: "image_selfie_.jpg",
                                    selfieImgLink: response.link,
                                    isLoading: false
                                });
                            }
                        })  .catch(error => {
                        this.setState({
                            isLoading: false
                        });
                        displayGenericError(error);
                    });
                }
            })
            .catch(error => {
                this.setState({
                    isLoading: false
                });
                displayGenericError(error);
            });
    }
    isWeekend = (date) =>{
        return date.getDay() === 6 || date.getDay() === 0;
    }
    handleTimeChange =(time, timeString) =>{
       this.setState({
           selectTime:timeString
       })
    }
    handleDayClick = (day, { selected }) =>{
       if(!this.isWeekend(day)){
           this.setState({
               selectedDay: selected ? undefined : day,

           },()=>{

               this.setState({
                   dateSelect: moment(this.state.selectedDay).format('DD/MM/YYYY')
               });
           });
       }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if(prevProps.currentTab!=2 && this.props.currentTab==2 ) {
            this.setState({
                onboardingType: 'selfie'
            })
        }
    }

    setRef = webcam => {
        this.webcam = webcam;
    };
    recapture = () => {
        this.setState({
            selfieImageName:'',
            selfieImgLink:''
        })
    }

    flipImage = (imageBase64, cb) => {
        if(imageBase64==null){
            displayError("Please allow camera to capture.");
            this.setState({
                isLoading: false,
                isOnCamera: false
            });
            return;
        }
        var img = new Image();
        img.src = imageBase64;
        img.onload = () => {
          var canvas = document.createElement("canvas");
          // var canvas = document.createElement("canvas");
          canvas.width = img.width;
          canvas.height = img.height;
          var ctx = canvas.getContext("2d");
          ctx.scale(-1,1);
          ctx.drawImage(img, -img.width, 0, img.width, img.height);
          cb(canvas.toDataURL("image/jpeg"))
        };
    }
    capture = () => {
        const imageSrc = this.webcam.getScreenshot();
        this.setState({
            isLoading: true
        });
        this.flipImage(imageSrc, (url) => {
            if(url==null) {
                this.setState({
                    isLoading: false
                });
                return;
            }
            fetch(url)
                .then(res => res.blob())
                .then(blob => {
                    const file = new File([blob], "image_selfie_.jpg",{ type: "image/jpeg" })
                    let type ='SELFIE';
                    return upload({id: this.props.customerAccount.id, file, type})
                        .then(res => {
                            generateUploadedFileNotDownload(res.id)
                                .then(response => {
                                    this.setState({
                                        selfieImageName: file.name,
                                        selfieImgLink: response,
                                        isLoading: false
                                    });
                                })  .catch(error => {
                                this.setState({
                                    isLoading: false
                                });
                                displayGenericError(error);
                            });

                            displaySuccessMessage("Capture photo success");
                        })
                        .catch(error => {
                            this.setState({
                                isLoading: false
                            });
                            displayGenericError(error);
                        });
                })
            });
        /*
        fetch(imageSrc)
            .then(res => res.blob())
            .then(blob => {
                const file = new File([blob], "image_selfie_.jpg",{ type: "image/jpeg" })
                let type ='SELFIE';
                return upload({id: this.props.customerAccount.id, file, type})
                    .then(res => {
                        generateCustomerFileDownloadLink(res.id)
                            .then(response => {
                                this.setState({
                                    selfieImageName: file.name,
                                    selfieImgLink: response.link,
                                    isLoading: false
                                });
                            })  .catch(error => {
                            this.setState({
                                isLoading: false
                            });
                            displayGenericError(error);
                        });

                        displaySuccessMessage("Capture photo success");
                    })
                    .catch(error => {
                        this.setState({
                            isLoading: false
                        });
                        displayGenericError(error);
                    });
            })
        */
    };

    render() {

        const { isSubmitted } = this.state;

        const videoConstraints = {
            width: { min: 570 },
            height: { min: 720 },
            //aspectRatio: 0.6666666667,
            facingMode: "user",
            noiseSuppression: true
        };

        const nextTwoWeeks = new Date();
        nextTwoWeeks.setDate(nextTwoWeeks.getDate() + 14);

        if (this.state.isLoading) {
            return <LoadingIndicator />;
        }
        return (
            <div className="general-info-tab">
                <div className="left-pane">
                    <Row gutter={24}>
                        <Col md={12}>
                            <Title level={4}>Personal Document</Title>
                            <div>
                                <Form.Item
                                    label="Document Type">
                                    <Radio.Group name="documentType" value={this.state.documentType}
                                                onChange={this.onDocumentTypeChange}>
                                        <Radio.Button value="identityCard" >Identity Card</Radio.Button>
                                        <Radio.Button value="passport" >Passport</Radio.Button>
                                    </Radio.Group>
                                </Form.Item>
                            </div>

                            {this.state.documentType === 'passport' &&(
                                <div>
                                    <UploadWrapper
                                        upload={this.handleUpload}
                                        file={
                                            this.state.documents[
                                                "PASSPORT"
                                                ]
                                        }
                                        title="Passport (Minimum 6 month's validity period)"
                                        type="PASSPORT"
                                        handleRemoveFile={this.handleRemoveFile}
                                        disabled={isSubmitted}
                                    />
                                </div>
                            )}
                            {this.state.documentType === 'passport' &&(
                                <div>
                                    <UploadWrapper
                                        upload={this.handleUpload}
                                        file={
                                            this.state.documents[
                                                "PROOF_OF_ADDRESS"
                                                ]
                                        }
                                        title="Proof of Residential Address"
                                        type="PROOF_OF_ADDRESS"
                                        handleRemoveFile={this.handleRemoveFile}
                                        disabled={isSubmitted}
                                    />
                                </div>
                            )}

                            {this.state.documentType === 'identityCard' &&(
                                <div id="div_id_front">
                                    <UploadWrapper
                                        upload={this.handleUpload}
                                        file={
                                            this.state.documents[
                                                "IDENTITY_CARD_FRONT"
                                                ]
                                        }
                                        title="Identity Card (Front)"
                                        type="IDENTITY_CARD_FRONT"
                                        handleRemoveFile={this.handleRemoveFile}
                                        disabled={isSubmitted}
                                        
                                    />
                                </div>
                            )}
                            {this.state.documentType === 'identityCard' &&(
                                <div id="div_id_back">
                                    <UploadWrapper
                                        upload={this.handleUpload}
                                        file={
                                            this.state.documents[
                                                "IDENTITY_CARD_BACK"
                                                ]
                                        }
                                        title="Identity Card (Back)"
                                        type="IDENTITY_CARD_BACK"
                                        handleRemoveFile={this.handleRemoveFile}
                                        disabled={isSubmitted}
                                    />
                                </div>
                            )}
                        </Col>
                        {this.state.documentType === 'passport' &&(
                            <Col md={12}>
                                <div style={{textAlign: 'center', color:'#9b9b9b'}}><label>SAMPLE</label></div>
                                <Form.Item>
                                    <img className="passport" src={passport} />
                                </Form.Item>
                            </Col>
                        )}
                        {this.state.documentType === 'identityCard' &&(
                            <Col md={12}>
                                <div style={{textAlign: 'center', color:'#9b9b9b'}}><label>SAMPLE</label></div>
                                <Form.Item >
                                    <img className="id-card" src={idCard} />
                                </Form.Item>
                            </Col>
                        )}
                    </Row>
                    <Divider/>
                    <Row gutter={24}>
                        <Col>
                            <Form.Item
                                label="Identity Verification">
                                <Radio.Group name="onboardingType" value={this.state.onboardingType}
                                             onChange={this.onBoadingTypeChange}>
                                    <Radio.Button id ="btn_webcam" value="selfie" >Webcam Selfie</Radio.Button>
                                    <Radio.Button id = "btn_video_call" value="timeSchedule">Video Call</Radio.Button>
                                </Radio.Group>
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row gutter={24}>
                        <Col md={24}>
                            <div>{this.state.guiText}</div>
                        </Col>
                    </Row>
                    {this.state.onboardingType === 'timeSchedule' &&(
                    <Row gutter={24}>
                        <Col className="gutter-row" md={8}>
                            <Form.Item
                                label= {this.state.selectedDay
                                ? 'Selected Date: ' + this.state.selectedDay.toLocaleDateString()
                                : 'Select Date'}>
                            </Form.Item>
                            <DayPicker 
                            id = "day_picker"
                            disabledDays={ [
                                new Date(),
                                { daysOfWeek: [0, 6] },
                                { before: new Date() },
                                { after: nextTwoWeeks}
                            ]} selectedDays={this.state.selectedDay} onDayClick={this.handleDayClick} />
                        </Col>
                        <Col className="gutter-row"  md={16}>
                            <Form.Item
                            id = "select_time"
                                label="Select time">
                            </Form.Item>
                            <TimePicker
                                id = "time_picker"
                                onChange={this.handleTimeChange}
                                minuteStep={15}
                                disabledHours={() => [0, 1, 2, 3, 4, 5, 6, 7, 8, 18, 19, 20, 21, 22, 23]}
                                hideDisabledOptions={true}
                                format={'HH:mm'}
                            />
                        </Col>
                    </Row>
                    )}
                    {/*{this.state.onboardingType === 'selfie' &&(<img className="id-selfie" src={idSelfie} />)}*/}
                    {this.state.onboardingType === 'selfie' && this.state.selfieImgLink !== '' && (
                        <Row gutter={24}>
                            <Col className="gutter-row" md={12}> 
                                <img src={this.state.selfieImgLink} className="image-responsive"/>
                                <Button
                                    className="bt-next"
                                    type="primary"
                                    disabled={isSubmitted}
                                    onClick={this.recapture}>
                                    Recapture photo
                                </Button>
                            </Col>
                            <Col className="gutter-row" md={12}> 
                                <div style={{textAlign:'center'}}>
                                    <label>Please hold your NRIC/Passport next to your face</label>
                                </div>
                                <img className="id-selfie" src={idSelfie}/>
                            </Col>
                        </Row>
                    )}
                    {this.state.onboardingType === 'selfie' && this.state.selfieImgLink === '' && (
                        <Row gutter={24}>
                            <Col className="gutter-row" md={12} >
                                {this.state.isOnCamera ? (<>
                                    <Webcam ref={this.setRef}
                                    audio ={false}
                                    screenshotQuality={1}
                                    forceScreenshotSourceSize={true}
                                    mirrored={true}
                                    imageSmoothing={true}
                                    screenshotFormat="image/jpeg"
                                    videoConstraints={videoConstraints}
                                    width={'100%'}
                                    />
                                <Button
                                    className="bt-next"
                                    type="primary"
                                    onClick={this.capture}>
                                    Capture photo
                                </Button>
                                    </>): (<div style={{width: "500px", height: "290px"}}></div>)}
                                <span> Camera: <Switch checkedChildren="ON" checked={this.state.isOnCamera} unCheckedChildren="OFF" onChange={this.toggleCamera}/>
                                </span>
                            </Col>
                            <Col className="gutter-row" md={12}>
                                <div style={{textAlign:'center'}}>
                                    <label>Please hold your NRIC/Passport next to your face</label>
                                </div>
                                <img className="id-selfie" src={idSelfie}/>
                            </Col>
                        </Row>

                    )}

                    <Row gutter={24}>
                        <Col md={24}>
                            <div className="button-wrapper">
                                <Button className="bt-skip" onClick={this.props.prevTab}>
                                    Back
                                </Button>
                                <Button
                                    className="bt-next"
                                    type="primary"
                                    onClick={this.handleSubmit}
                                    disabled={this.isSubmitButtonDisabled()}>
                                    Submit
                                </Button>
                                {this.isSubmitButtonDisabled() && (
                                    <>
                                        <br/><i>*Please upload your Personal Document</i>
                                    </>
                                )}

                            </div>
                        </Col>
                    </Row>
                    {/*
                    <Row gutter={24}>
                        <Col md={24}>
                            <Text><b>Personal Details</b></Text>
                            <Paragraph>
                                We are required to collect your Identity Documents.
                            </Paragraph>
                            <Paragraph>
                                Supported file types: PDF, Word, JPG, JPEG, PNG, BMP up to 10MB.
                            </Paragraph>
                        </Col>
                    </Row>
                    */}
                </div>


            </div>
        );
    }
}


export default DocumentIndividualUploadingTab;
